var _defs, _polygon, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592 592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:40px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "475.13 177.06 424.16 123.35 296 244.96 167.84 123.35 116.87 177.06 242.21 296 116.87 414.94 167.84 468.65 296 347.04 424.16 468.65 475.13 414.94 349.79 296 475.13 177.06"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 20,
    width: 552,
    height: 552,
    rx: 47.98,
    ry: 47.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledRect);
export default __webpack_public_path__ + "static/media/cancelled-rect.ac951e4c0c428cbf828b1ac42e9d97c7.svg";
export { ForwardRef as ReactComponent };